module.exports = require("./it.d.ts");